import { Component, EventEmitter, Output } from '@angular/core';
import { PhoneAppState } from 'projects/store/src/app/services/api/v1/phone-app-status.service';

@Component({
  selector: 'app-sales-phone-absolute-platform',
  templateUrl: './sales-phone-absolute-platform.component.html'
})
export class SalesPhoneAbsolutePlatformComponent {
  @Output() nextStep = new EventEmitter<void>();

  readonly appState = PhoneAppState.Ready;

  onContinue(): void {
    this.nextStep.emit();
  }
}